var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "select-rates",
    {
      attrs: { "bid-id": _vm.bidId },
      on: { cancel: _vm.cancel, hide: _vm.hide, submit: _vm.hide },
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("h1", { class: _vm.$style.headerMain }, [
          _vm._v("Edit Accepted Rates"),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }